__turbopack_context__.v({
  "item": "iv8H7q_item",
  "loading": "iv8H7q_loading",
  "shine": "iv8H7q_shine",
});
